class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").updateQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );

    this.emptyCartItem = this.querySelector("#min-cart-items");
    this.cartItemMessageShow = this.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = this.querySelector("#empty__cart__button");

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.addEventListener("click", (event) => {
      const closeButton = event.target.closest(
        "button.cart-notification__close"
      );

      if (!closeButton || !this.contains(closeButton)) return;

      event.preventDefault();
      event.stopPropagation();
      this.close();
    });

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
      // document
      //   .querySelector(".cart_action_drawer_overlay")
      //   .classList.add("active");
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  renderContents(parsedState, options = {}) {
    const { open = true } = options;
    const sections = parsedState?.sections || {};

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      const sectionHTML = sections[section.id];
      if (!elementToReplace || !sectionHTML) return;

      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML);
    });

    const itemCount = this.getCartItemCount(parsedState);
    this.updateCartCountBubble(itemCount);
    this.setCartEmptyState(itemCount === 0);

    if (this.header) this.header.reveal();
    if (open) this.open();
  }

  getCartItemCount(parsedState) {
    if (typeof parsedState?.item_count === "number") {
      return parsedState.item_count;
    }

    const countSection = parsedState?.sections?.["cart-notification-count"];
    if (countSection) {
      const parsed = parseInt(
        this.getSectionInnerHTML(countSection).replace(/[^\d-]/g, ""),
        10
      );
      if (Number.isFinite(parsed)) return parsed;
    }

    const countEl = document.getElementById("cart-notification-count");
    if (countEl) {
      const parsed = parseInt(countEl.textContent, 10);
      if (Number.isFinite(parsed)) return parsed;
    }

    return document.querySelector(
      "#cart-notification-product .cart-notification-product"
    )
      ? 1
      : 0;
  }

  updateCartCountBubble(itemCount) {
    const countEls = document.querySelectorAll(
      '.header__actions_btn_cart_num span[id="cart-notification-count"]'
    );
    countEls.forEach((countEl) => {
      countEl.textContent = String(itemCount);
    });

    const isEmpty = itemCount === 0;
    document
      .querySelectorAll(".header__actions_btn--cart .cart-count-bubble")
      .forEach((bubble) => {
        bubble.toggleAttribute("hidden", isEmpty);
        bubble.classList.toggle("is-empty", isEmpty);
      });
  }

  setCartEmptyState(isEmpty) {
    this.emptyCartItem =
      this.emptyCartItem ||
      this.querySelector("#min-cart-items") ||
      document.getElementById("min-cart-items");
    this.emptyCartButtonDisable =
      this.emptyCartButtonDisable ||
      this.querySelector("#empty__cart__button") ||
      document.getElementById("empty__cart__button");
    this.cartItemMessageShow =
      this.cartItemMessageShow || this.querySelector(".empty__cart__item");
    this.cartAddSuccess =
      this.cartAddSuccess || this.querySelector(".item__success_message");
    this.cartEmptyHead =
      this.cartEmptyHead || this.querySelector(".item__empty_message");

    this.emptyCartItem?.classList.toggle("no-js-inline", isEmpty);
    this.emptyCartButtonDisable?.classList.toggle("no-js-inline", isEmpty);
    this.cartItemMessageShow?.classList.toggle("no-js-inline", !isEmpty);
    this.cartAddSuccess?.classList.toggle("no-js-inline", isEmpty);
    this.cartEmptyHead?.classList.toggle("no-js-inline", !isEmpty);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount",
      },
    ];
  }

  getCartRootUrl() {
    const root = window.Shopify?.routes?.root || "/";
    return new URL("cart", `${window.location.origin}${root}`);
  }

  getSectionsRenderUrl() {
    return this.getCartRootUrl().pathname;
  }

  cartHasProductMarkup() {
    return Boolean(
      this.querySelector("#cart-notification-product .cart-notification-product")
    );
  }

  fetchCartJson() {
    const url = this.getCartRootUrl();
    url.pathname = `${url.pathname}.js`;

    return fetch(url.toString(), {
      credentials: "same-origin",
      cache: "no-store",
    }).then((response) => {
      if (!response.ok) throw new Error("Failed to fetch cart");
      return response.json();
    });
  }

  fetchCartSectionsFromApi() {
    const sectionIds = this.getSectionsToRender().map((section) => section.id);
    const updateUrl =
      window.routes?.cart_update_url || `${this.getCartRootUrl().pathname}.js`;

    return fetch(updateUrl, {
      ...fetchConfig(),
      body: JSON.stringify({ sections: sectionIds }),
    }).then((response) => {
      if (!response.ok) throw new Error("Failed to fetch cart sections");
      return response.json();
    });
  }

  fetchMiniCartMarkup() {
    const url = this.getCartRootUrl();
    url.searchParams.set("view", "minicart");
    url.searchParams.set("t", String(Date.now()));

    return fetch(url.toString(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "text/html" },
    }).then((response) => {
      if (!response.ok) throw new Error("Failed to fetch mini-cart");
      return response.text();
    });
  }

  applyMiniCartMarkup(html) {
    const parsedDocument = new DOMParser().parseFromString(html, "text/html");

    this.getSectionsToRender().forEach((section) => {
      const source = parsedDocument.getElementById(`${section.id}-html`);
      const target = document.getElementById(section.id);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    return this.cartHasProductMarkup();
  }

  applyParsedSections(parsedState) {
    const sections = parsedState?.sections || {};
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      const sectionHTML = sections[section.id];
      if (!elementToReplace || !sectionHTML) return;
      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML);
    });
    return this.cartHasProductMarkup();
  }

  formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const amountWithComma = amount.replace(".", ",");
    const format =
      this.dataset.moneyFormat ||
      window.theme?.moneyFormat ||
      "€{{amount_with_comma_separator}}";

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  escapeHtml(value) {
    const element = document.createElement("div");
    element.textContent = value == null ? "" : String(value);
    return element.innerHTML;
  }

  renderProductCardsFromCart(cart) {
    const productRoot = document.getElementById("cart-notification-product");
    const subtotalEl = document.getElementById("cart-notification-subtotal");
    if (!productRoot || !cart?.items?.length) return false;

    const removeText = this.dataset.removeText || "Remove";

    productRoot.innerHTML = cart.items
      .map((item, index) => {
        const line = index + 1;
        const image = item.image
          ? `<a href="${this.escapeHtml(item.url)}" class="cart-notification__product--image">
              <img class="cart-notification-product__image" src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.product_title || item.title)}" width="130" height="150" loading="lazy">
            </a>`
          : "";
        const options = (item.options_with_values || [])
          .filter((option) => option.name !== "Title" || option.value !== "Default Title")
          .map(
            (option) =>
              `<span class="cart-notification-product__option"><span><b>${this.escapeHtml(option.name)}:</b></span> <span>${this.escapeHtml(option.value)}</span></span>`
          )
          .join("");

        return `<div class="cart-notification-product" data-item-id="${this.escapeHtml(item.id)}">
          ${image}
          <div class="cart-notification-product__info">
            <h6 class="cart-notification-product__name"><a href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.product_title || item.title)}</a></h6>
            ${options}
            <div class="cart__item_price"><span class="price">${this.formatMoney(item.final_line_price)}</span></div>
            <div class="cart-notification__quantity-wrapper">
              <quantity-input class="quantity mt-10 cart-notification--product">
                <button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">-</span></button>
                <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" data-index="${line}" data-quantity-variant-id="${item.variant_id}" id="Quantity-${line}">
                <button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">+</span></button>
              </quantity-input>
              <cart-remove-button-2 class="cart-close-icon" id="Remove-${line}" data-index="${line}">
                <button class="link" type="button">${this.escapeHtml(removeText)}</button>
              </cart-remove-button-2>
            </div>
          </div>
        </div>`;
      })
      .join("");

    if (subtotalEl) {
      subtotalEl.textContent = this.formatMoney(cart.total_price);
    }

    return this.cartHasProductMarkup();
  }

  paintCart(cart, parsedState, open) {
    this.applyParsedSections({
      ...parsedState,
      item_count: cart.item_count,
    });

    if (cart.item_count > 0) {
      this.renderProductCardsFromCart(cart);
    }

    if (cart.item_count === 0) {
      const productRoot = document.getElementById("cart-notification-product");
      if (productRoot) productRoot.innerHTML = "";
    }

    this.updateCartCountBubble(cart.item_count);
    this.setCartEmptyState(cart.item_count === 0);
    if (this.header) this.header.reveal();
    if (open) this.open();
    return cart;
  }

  syncCart(options = {}, parsedState = {}) {
    const { open = true } = options;

    return this.fetchCartJson()
      .then((cart) => this.paintCart(cart, parsedState, open))
      .catch((error) => {
        console.error(error);
        if (parsedState?.sections) {
          this.renderContents(parsedState, { open });
        }
        if (parsedState && !this.cartHasProductMarkup()) {
          this.renderProductCardsFromCart(parsedState);
        }
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        return this.syncCart({ open: false }).then(() => {
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;
          let message = "";
          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantity)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace(
                "[quantity]",
                updatedValue
              );
            }
          }
          this.updateLiveRegions(line, message);

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-notification",
            cartData: parsedState,
            variantId: variantId,
          });
        });
      })
      .catch(() => {
        // const errors =
        //   document.getElementById("cart-errors") ||
        //   document.getElementById("CartDrawer-CartErrors");
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return "";

    const parsedDocument = new DOMParser().parseFromString(html, "text/html");
    const sectionEl = parsedDocument.querySelector(selector);
    return sectionEl ? sectionEl.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );

    this.notification
      .querySelector("button.cart-notification__close")
      .addEventListener("click", this.miniCartClose.bind(this));
  }

  onClickMiniCart() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        if (!this.notification.classList.contains("active")) return;

        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.removeEventListener("click", this.onBodyClassRemove);
    document.body.addEventListener("click", this.onBodyClassRemove);
    this.refreshMiniCart();
  }

  refreshMiniCart() {
    const cartNotification = document.querySelector("cart-notification");
    if (!cartNotification?.syncCart) return;

    cartNotification.syncCart({ open: false });
  }

  miniCartClose() {
    this.notification.classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(this.cartButton);
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
